<template lang="html">
  <div class="text-h6 my-2">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name:"VParagraphTitle"
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/varticle/VParagraphTitle.vue